import React, {
  useCallback,
  useContext,
  useState,
  useEffect,
} from "react";
import {
  Col,
  Row,
  Card,
  Form,
  InputGroup,
  Button,
  Dropdown,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faSearch, faFilter, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from "react-cookie";
import { Context } from "../RewardCombined";
import { getAllChannel } from "../../../../controller/api/__classic__/channel";
import { includesSearchText } from "../../../../helper/text";
import { exportAllReward } from "../../../../controller/api/__classic__/reward";
import { exportClassicRewardToExcel } from "../../../../helpers/excelExport";

const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [from, setFrom] = useState(state.filter.from);
  const [to, setTo] = useState(state.filter.to);
  const [phone, setPhone] = useState(state.filter.phone || "");
  const [region, setRegion] = useState(state.filter.region || "ALL");
  const [channelId, setChannelId] = useState(state.filter.channelId || "");
  const [channelSearch, setChannelSearch] = useState("");
  const [channels, setChannels] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    const fetchChannels = async () => {
      setChannelId("");
      const r = region === "ALL" ? "MN" : region;
      const response = await getAllChannel(cookies.lottmekong, r);
      if (response && response.data) {
        setChannels(response.data);
      } else {
        setChannels([]);
      }
    };
    fetchChannels();
  }, [region, cookies.lottmekong]);

  const filteredChannels = channelSearch
    ? channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : channels;

  const _submitForm = useCallback(() => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        from,
        to,
        phone,
        region,
        channelId,
      },
    });
  }, [dispatch, from, to, phone, region, channelId]);

  const handleExportExcel = async () => {
    setIsExporting(true);
    try {
      let phoneQuery = state.filter.phone || '';
      if (phoneQuery && phoneQuery.indexOf('MB') < 0 && phoneQuery.startsWith('0')) {
        phoneQuery = phoneQuery.replace('0', '+84');
      }

      const query = {
        from: state.filter.from,
        to: state.filter.to,
        phone: phoneQuery,
        region: state.filter.region || 'ALL',
      };

      const response = await exportAllReward(cookies.lottmekong, query);
      if (response && response.data) {
        exportClassicRewardToExcel(response.data, state.filter, state.filter.region || 'ALL');
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Xuất Excel thất bại. Vui lòng thử lại!');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Card border="light" className="shadow-sm border-0 mb-3">
      <Card.Body className="p-3">
        <div className="d-flex align-items-center mb-3">
          <div className="icon icon-shape icon-sm shadow-sm border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
            <FontAwesomeIcon icon={faFilter} className="text-primary" />
          </div>
          <h6 className="mb-0">Trúng thưởng Truyền thống</h6>
        </div>

        <Row className="g-3 align-items-end">
          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Miền</Form.Label>
            <Form.Select
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              className="bg-white"
            >
              <option value="ALL">Tất cả</option>
              <option value="MN">Miền Nam</option>
              <option value="MT">Miền Trung</option>
              <option value="MB">Miền Bắc</option>
            </Form.Select>
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đài</Form.Label>
            <Dropdown className="w-100">
              <Dropdown.Toggle
                variant="white"
                className="w-100 text-start d-flex align-items-center justify-content-between form-control bg-white border"
                id="dropdown-channel-select"
              >
                <span className="text-truncate">
                  {channelId
                    ? channels.find(
                        (ch) => String(ch.id) === String(channelId),
                      )?.name || "Tất cả đài"
                    : "Tất cả đài"}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="w-100 p-2 shadow-sm"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <div className="px-1 mb-2 sticky-top bg-white">
                  <InputGroup>
                    <InputGroup.Text className="bg-white border-end-0">
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="text-muted"
                      />
                    </InputGroup.Text>
                    <Form.Control
                      autoFocus
                      placeholder="Tìm đài..."
                      value={channelSearch}
                      onChange={(e) => setChannelSearch(e.target.value)}
                      className="bg-white border-start-0 ps-0"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </InputGroup>
                </div>

                <Dropdown.Item
                  active={channelId === ""}
                  onClick={() => {
                    setChannelId("");
                    setChannelSearch("");
                  }}
                  className="rounded-2"
                >
                  Tất cả đài
                </Dropdown.Item>

                {filteredChannels.length > 0 ? (
                  filteredChannels.map((channel) => (
                    <Dropdown.Item
                      key={channel.id}
                      active={String(channelId) === String(channel.id)}
                      onClick={() => {
                        setChannelId(channel.id);
                        setChannelSearch("");
                      }}
                      className="rounded-2"
                    >
                      {channel.name}
                    </Dropdown.Item>
                  ))
                ) : (
                  <div className="text-center text-muted small py-2">
                    Không tìm thấy đài
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
            <Datetime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              onChange={setFrom}
              value={from}
              renderInput={(props, openCalendar) => (
                <InputGroup className="input-group-merge">
                  <InputGroup.Text className="bg-white border-end-0">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    className="border-start-0 ps-0"
                    value={from ? moment(from).format("DD/MM/YYYY") : ""}
                    placeholder="Chọn ngày"
                    onFocus={openCalendar}
                    onChange={() => {}}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col xs={12} md={6} xl={2}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
            <Datetime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              onChange={setTo}
              value={to}
              renderInput={(props, openCalendar) => (
                <InputGroup className="input-group-merge">
                  <InputGroup.Text className="bg-white border-end-0">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    className="border-start-0 ps-0"
                    value={to ? moment(to).format("DD/MM/YYYY") : ""}
                    placeholder="Chọn ngày"
                    onFocus={openCalendar}
                    onChange={() => {}}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col xs={12} md={6} xl={4}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Điện thoại</Form.Label>
            <Form.Control
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              placeholder="Nhập SĐT"
              className="bg-white"
              onKeyDown={(e) => {
                if (e.key === "Enter") _submitForm();
              }}
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs={12} className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              onClick={_submitForm}
              className="shadow-sm"
              disabled={state.isLoading}
            >
              {state.isLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang tải...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} className="me-2" />
                  Tìm kiếm
                </>
              )}
            </Button>
            <Button
              variant="success"
              type="button"
              className="shadow-sm"
              disabled={isExporting || state.isLoading}
              onClick={handleExportExcel}
            >
              {isExporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang xuất...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                  Xuất Excel
                </>
              )}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm);
